import { Expose } from 'class-transformer';
import { IsConsentValid } from '../custom-validation-functions/is-consent-valid';

export class FiReview {
  @Expose()
  @IsConsentValid()
  isConsentChecked = false;
}
